// src/lib/providerApi.js
// Kleine helperlaag voor abonnementkoppeling (free / sports / all_access)

function resolveApiBase() {
  // 1. Dev: als we op localhost draaien → altijd de lokale backend gebruiken
  if (
    typeof window !== "undefined" &&
    window.location.hostname === "localhost"
  ) {
    return "http://localhost:5000";
  }

  // 2. Productie: bondapp.tv → productie backend
  if (
    typeof window !== "undefined" &&
    window.location.hostname === "bondapp.tv"
  ) {
    return "https://signal.bondapp.tv"; // productie backend
  }

  // 3. Optioneel: env override (staging/andere omgevingen)
  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }

  // 4. Fallback (dev)
  return "http://localhost:5000";
}

const API_BASE = resolveApiBase();

console.log("BOND PROVIDER_API_BASE =", API_BASE);

async function request(path, { method = "GET", body, token } = {}) {
  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const error = data?.error || "REQUEST_FAILED";
    throw new Error(error);
  }

  return data;
}

// ---- Publieke functies ----

// Haal alle providers op die de huidige user gekoppeld heeft
export async function getMyProviders(token) {
  const data = await request("/api/me/providers", { token });
  return data.providers || [];
}

// Koppel een provider aan de huidige user
// providerId: "free" | "sports" | "all_access"
export async function addProvider(providerId, token) {
  const data = await request("/api/me/providers", {
    method: "POST",
    body: { providerId },
    token,
  });
  return data.provider;
}
